module.exports = __webpack_public_path__ + "static/media/MT130.bc95f686.svg";